import { ForecastProviderV5 } from '../providers/forecastProviderV5';
import { AsyncAction } from '../../base-classes/asyncAction';
import { GetDailyForecastByLatLonV5Params } from '../../utilities/units';


export const GET_DAILY_FORECAST_BY_LATLON = new AsyncAction('GET_DAILY_FORECAST_BY_LATLON');


export function getDailyForecastByLatLonV5({location,
    locationType,
    offset,
    baseUrl,
    authId,
    secret,
    stdParameters,
    verbose = false,
    refresh = false,
    roundingProfile = 'displayV1',
    specificUnits} : GetDailyForecastByLatLonV5Params) {
    
    const forecastParams = {
        location,
        locationType,
        offset,
        baseUrl,
        authId,
        secret,
        stdParameters,
        verbose,
        refresh,
        roundingProfile,
        specificUnits
    }

    return {
        type: GET_DAILY_FORECAST_BY_LATLON.base,
        payload: getDailyForecastV5(forecastParams)
    };
}

export async function getDailyForecastV5({
    location,
    locationType,
    offset,
    baseUrl,
    authId,
    secret,
    stdParameters,
    verbose,
    refresh,
    roundingProfile,
    specificUnits
}) {
    const op = new ForecastProviderV5(baseUrl, authId, secret);
    return await op.getDailyForecastV5(
        location,
        locationType,
        offset,
        stdParameters,
        verbose,
        refresh,
        roundingProfile,
        specificUnits
    );
}
